/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stats_SalesInputs */

const he_dashboard_stats_sales = /** @type {(inputs: Dashboard_Stats_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מכירות`)
};

const en_dashboard_stats_sales = /** @type {(inputs: Dashboard_Stats_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales`)
};

/**
* | output |
* | --- |
* | "Sales" |
*
* @param {Dashboard_Stats_SalesInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_stats_sales = /** @type {((inputs?: Dashboard_Stats_SalesInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stats_SalesInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_stats_sales(inputs)
	return en_dashboard_stats_sales(inputs)
});